export const ButtonOfCollection = ({ text, isActive, onClick, classNames }) => {
  return (
    <button
      className={`${
        isActive ? "border-tertiary" : "border-transparent"
      } ${classNames} transition-colors flex justify-center items-center min-w-[30px] min-h-[30px] p-[10px] border-[1px] border-solid rounded-[5px]`}
      onClick={onClick}
    >
      <p className="text-secondary text-sm font-normal">{text}</p>
    </button>
  );
};

const ButtonCollection = ({ children }) => {
  return (
    <div className="w-fit h-[40px] flex flex-row justify-around items-center gap-1.5 sm:gap-3 p-[5px] border-[1px] border-solid border-[#1E1E1E] bg-[#1E1E1E] rounded-[5px]">
      {children}
    </div>
  );
};

export default ButtonCollection;
